// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list___o_CF","list__heading":"List_list__heading__vjodu","list__items":"List_list__items__pNqUd"};